import React from "react";

function TwitterIcon({
  startColor = "#004d00",
  endColor = "#00e600",
  size = "w-8 h-8",
}) {
  const gradientId = `twitterIconGradient-${startColor}-${endColor}`;

  return (
    <svg
      className={size}
      viewBox="470 350 720 600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={startColor} />
          <stop offset="100%" stopColor={endColor} />
        </linearGradient>
      </defs>
      <path
        d="M485.39,356.79l230.07,307.62L483.94,914.52h52.11l202.7-218.98l163.77,218.98h177.32 L836.82,589.6l215.5-232.81h-52.11L813.54,558.46L662.71,356.79H485.39z M562.02,395.17h81.46l359.72,480.97h-81.46L562.02,395.17 z"
        fill={`url(#${gradientId})`}
      />
    </svg>
  );
}

export default TwitterIcon;
